import type { Observable } from 'rxjs';
import type { HttpDataResponse } from '@common/types/http-response.type';
import type { SiteListEntity } from '@common/types/site.type';

import { Injectable } from '@angular/core';
import { shareReplay } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseHttpService } from '@common/services/REST/base.http.service';
import type { EContentSources } from '@common/enums';

@Injectable({
    providedIn: 'root',
})
export class SitesHttpService extends BaseHttpService {
    public getSites(contentSourceIds: EContentSources[]): Observable<SiteListEntity[]> {
        return this.http
            .get<HttpDataResponse<SiteListEntity[]>>(this.formatApiUrl(`sites/list`), {
                params: {
                    page: '1',
                    perPage: '200',
                    contentSourceIds: contentSourceIds.join(','),
                },
            })
            .pipe(
                shareReplay(),
                map((response) => response.data)
            );
    }
}
